import { ACCESS_TOKEN_KEY, getEnv } from '@src/core/config';
import Axios from 'axios';
import { routesConfig } from '@src/core/routes';

export const axios = Axios.create({
  baseURL: getEnv('REACT_APP_API_BASE_URL'),
  responseType: 'json',
  timeout: 60000,
});

axios.interceptors.request.use((request: any) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (token) {
    request.headers["Authorization"] = `Bearer ${token}`;
  }
  request.headers["Content-Type"] = "application/json";
  return request;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 412) {
      window.location.href = routesConfig.agreement;
      return new Promise(() => {});
    }

    // A 401 means the session is no longer valid (e.g. expired/invalid token). Drop the
    // stale token and send the user to sign in. Skip when already on an auth page so the
    // sign-in form can surface its own 401 (wrong credentials) without a redirect loop.
    if (status === 401 && !window.location.pathname.startsWith(routesConfig.auth)) {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      window.location.href = routesConfig.signIn;
      return new Promise(() => {});
    }

    return Promise.reject(error);
  }
);

